import { Consumer } from '../Context'
import Loader from './Loader'

const CATEGORIES = [
  'Account Management',
  'Applications',
  'Calendar',
  'Hardware',
  'iPad',
  'Loan',
  'Poster Request',
  'Requests',
  'Samanage Setup',
  'Server',
  'Supplemental Application',
  'WiFi',
  'Wireless Printing',
]

export default function Incident() {
  return (
    <Consumer>
      {(props) => (
        <form onSubmit={props.createIncident}>
          <div className="form-group mb-5">
            <label htmlFor="category">Category of Problem</label>
            <select id="category" name="category" className="form-control no-pad select-caret">
              {CATEGORIES.map((category) => (
                <option key={category} value={category}>
                  {category}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="description">Description of Problem:</label>
            <textarea
              id="description"
              className="form-control"
              name="description"
              rows="5"
              placeholder="Tell us about the problem..."
              required
            />
          </div>
          <button
            type="submit"
            disabled={props.loading}
            className="d-flex btn btn-primary ml-auto button__load"
          >
            {props.loading ? <Loader /> : <span>Submit</span>}
          </button>
        </form>
      )}
    </Consumer>
  )
}
